// User Service: Handles user details API
import request from '../utils/request';

const USER_DETAILS_URL = process.env.REACT_APP_API_URL + '/user/details';

export const getUserDetails = async () => {
  return request(USER_DETAILS_URL, {
    method: 'GET',
    headers: {
      'Accept': 'application/json, text/plain, */*'
    },
    credentials: 'include',
  });
};

export default {
  getUserDetails,
};
